import { RoleServiceType } from '@/services/api/roleApiArea/interface';
import { RoleService } from '@/services/api/roleApiArea/RoleService';

/** Метод roleApiArea возвращает экземпляр GroupService. По необходимости можно реализовать снгл тон. **/
export const roleApiArea: { (): RoleServiceType } = () => new RoleService();
